import { navigationDrawerConstants } from '@/constants/navigationDrawerConstants';

export const showNavigationDrawer = ({ show }: { show: boolean }) => {
  return { type: navigationDrawerConstants.NAVIGATION_DRAWER, data: show };
};
